// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"id":"caret-left-small","fill":"props.strokeColor1","d":"M14.5 6.5L14.5 17.5L9 12L14.5 6.5Z"}}]};

const CaretLeftSmallIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'caret-left-small',
    ref,
    icon: element,
  },
));

CaretLeftSmallIcon.displayName = 'CaretLeftSmallIcon';

export default CaretLeftSmallIcon;
